import type { EUserRoles } from '@entities/user/lib/const';
import { capitalize } from '@mui/material';

export const getUserStatus = (isBlocked?: boolean) => (isBlocked ? 'Blocked' : 'Active');

export const humanizeUserRole = (userRole?: EUserRoles) => (userRole ? capitalize(userRole.replace(/_/g, ' ')) : '');
